import { Component, OnInit, ViewChild } from '@angular/core';
import { InputComponent, MakeProvider } from '../input-component';
import { IonInput } from '@ionic/angular';

@Component({
  selector: 'app-phone-input',
  templateUrl: './phone-input.component.html',
  styleUrls: ['./phone-input.component.scss'],
  providers: [MakeProvider(PhoneInputComponent)]
})
export class PhoneInputComponent extends InputComponent implements OnInit {

  @ViewChild('phoneInput', { static: false }) phoneInput?: IonInput;

  key?: string;
  override maxLength = 15;

  constructor() { super(); }

  ngOnInit() {
    setTimeout(() => {
      if (this.phoneInput) {
        this.phoneInput.value = this.value;
        document.getElementById(this.id)?.addEventListener('keydown', (event) => {
          this.key = event.key;
        });
      }
    });
  }

  maskInput(event: any) {
    const arr: string[] = this.getNumbers(event.target.value);
    // checks if delete or backspace key was hit
    // if it was hit we shorten the length of the number by 1
    if (this.key === 'Backspace' || this.key === 'Delete') {
      if (arr.length > 0) {
        arr.length = arr.length - 1;
      }
      this.key = undefined;
    }
    const numbers = arr.join('');
    this.value = numbers;
    event.target.value = numbers.length > 0 ? `(${numbers.slice(0, 3)}) ${numbers.slice(3, 6)}-${numbers.slice(6, 10)}` : '';
  }

  override checkValidity() {
    const numbers = this.getNumbers(this.value);
    if (numbers.length < 10) {
      this.focusInvalidElement('Enter a valid phone number.');
    } else {
      this.isValid = true;
      this.checkingValidity.emit(this);
    }
  }

  protected getNumbers(value: string) {
    if (value) {
      const val = value.toString();
      const arr: string[] = [];
      for (let i = 0; i < val.toString().length; i++) {
        //checks if input is a digit
        if (val[i]?.match('\\d')) {
          arr.push(val[i]!);
        }
      }
      return arr;
    }
    return [];
  }
}
